import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import {
  translateCareerLevel,
  translateJobType,
  translateSector,
} from "../../../utils/jobTranslations";
import { useLanguage } from "../../../context/LanguageContext";

const JobDetailsDescription = ({ job }) => {
  const { language } = useLanguage();
  if (!job)
    return (
      <div className="text-center py-5">
        {language === "pt" ? "Vaga não encontrada" : "Job not found"}
      </div>
    );

  const {
    title,
    description,
    type,
    yearsOfExperience,
    careerLevel,
    sector,
    responsibilities = [],
    qualifications = [],
    skills = [],
    viewCount,
  } = job;

  return (
    <React.Fragment>
      <Card className="job-detail overflow-hidden">
        <CardBody className="p-4">
          <div>
            <Row>
              <Col md={8}>
                <h5 className="mb-1">{title}</h5>
                <ul className="list-inline text-muted mb-0">
                  <li className="list-inline-item">
                    <i className="mdi mdi-account"></i> {viewCount || "0"}{" "}
                    {language === "pt" ? "Visualizações" : "Views"}
                  </li>
                </ul>
              </Col>
            </Row>
          </div>

          <div className="mt-4">
            <Row className="g-2">
              <Col lg>
                <div className="border rounded-start p-3">
                  <p className="text-muted mb-0 fs-13">
                    {language === "pt" ? "Experiência" : "Experience"}
                  </p>
                  <p className="fw-medium fs-15 mb-0">
                    {yearsOfExperience || "N/A"}{" "}
                    {language === "pt" ? "Ano(s)" : "Year(s)"}
                  </p>
                </div>
              </Col>
              <Col lg>
                <div className="border p-3">
                  <p className="text-muted fs-13 mb-0">
                    {language === "pt" ? "Tipo de Emprego" : "Job Type"}
                  </p>
                  <p className="fw-medium mb-0">
                    {translateJobType(type, language)}
                  </p>
                </div>
              </Col>
              <Col lg>
                <div className="border p-3">
                  <p className="text-muted fs-13 mb-0">
                    {language === "pt" ? "Nível da Carreira" : "Career Level"}
                  </p>
                  <p className="fw-medium mb-0">
                    {translateCareerLevel(careerLevel, language)}
                  </p>
                </div>
              </Col>
              <Col lg>
                <div className="border rounded-end p-3">
                  <p className="text-muted fs-13 mb-0">
                    {language === "pt" ? "Setor" : "Sector"}
                  </p>
                  <p className="fw-medium mb-0">
                    {translateSector(sector, language)}
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="mt-4">
            <h5 className="mb-3">
              {language === "pt" ? "Descrição da Vaga" : "Job Description"}
            </h5>
            <div className="job-detail-desc">
              <p
                className="text-muted mb-0"
                dangerouslySetInnerHTML={{
                  __html:
                    description ||
                    (language === "pt"
                      ? "Nenhuma descrição fornecida."
                      : "No description provided."),
                }}
              />
            </div>
          </div>

          <div className="mt-4">
            <h5 className="mb-3">
              {language === "pt" ? "Responsabilidades" : "Responsibilities"}
            </h5>
            <div className="job-detail-desc mt-2">
              <ul className="job-detail-list list-unstyled mb-0 text-muted">
                {responsibilities.map((responsibility) => (
                  <li key={responsibility.id}>
                    <i className="uil uil-circle"></i> {responsibility.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-4">
            <h5 className="mb-3">
              {language === "pt" ? "Qualificações" : "Qualifications"}
            </h5>
            <div className="job-detail-desc mt-2">
              <ul className="job-detail-list list-unstyled mb-0 text-muted">
                {qualifications.map((qualification) => (
                  <li key={qualification.id}>
                    <i className="uil uil-circle"></i> {qualification.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-4">
            <h5 className="mb-3">
              {language === "pt"
                ? "Habilidades e Experiência"
                : "Skills and Experience"}
            </h5>
            <div className="job-details-desc">
              <ul className="job-detail-list list-unstyled mb-0 text-muted">
                {skills.map((skill) => (
                  <li key={skill.id}>
                    <i className="uil uil-circle"></i> {skill.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default JobDetailsDescription;
